import { TrendingUp } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FONT_BODY } from './theme';
import { Card } from './ui';

function Segmented({ t, label, value, options, onChange }) {
  return (
    <div>
      <div style={{ fontSize: 10, fontWeight: 700, color: t.textFaint, letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: 6 }}>{label}</div>
      <div role="radiogroup" aria-label={label} style={{ display: 'flex', gap: 4, padding: 3, borderRadius: 12, background: t.surfaceAlt }}>
        {options.map(o => {
          const on = o.value === value;
          return (
            <button key={o.value} role="radio" aria-checked={on} onClick={() => onChange(o.value)} style={{
              flex: 1, minHeight: 40, borderRadius: 9, border: 'none', cursor: 'pointer', fontFamily: FONT_BODY,
              background: on ? t.cardBg : 'transparent', color: on ? t.text : t.textMuted,
              boxShadow: on ? '0 1px 3px rgba(0,0,0,0.18)' : 'none', fontSize: 13, fontWeight: 600, padding: '6px 8px',
            }}>
              {o.label}
              {o.hint && <div style={{ fontSize: 11, fontWeight: 500, color: t.textFaint, marginTop: 1 }}>{o.hint}</div>}
            </button>
          );
        })}
      </div>
    </div>
  );
}

/* Profile: UI template and theme for this device (both device-local). */
export function AppearanceCard({ t, ui, onUi, isDark, onTheme, showTrading }) {
  return (
    <Card t={t} padding={20}>
      <div style={{ fontSize: 14, fontWeight: 700, color: t.text, marginBottom: 14 }}>Appearance</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        <Segmented t={t} label="Layout" value={ui} onChange={onUi} options={[
          { value: 'classic', label: 'Classic', hint: 'tabs on top' },
          { value: 'compact', label: 'Compact', hint: 'calmer, tabs below' },
        ]} />
        <Segmented t={t} label="Theme" value={isDark ? 'dark' : 'light'} onChange={onTheme} options={[
          { value: 'dark', label: 'Dark' },
          { value: 'light', label: 'Light' },
        ]} />
        {showTrading && (
          <Link to="/dashboard" style={{
            display: 'flex', alignItems: 'center', gap: 8, minHeight: 40, color: t.textMuted, textDecoration: 'none',
            fontSize: 13, fontWeight: 600,
          }}>
            <TrendingUp size={15} /> Open trading dashboard
          </Link>
        )}
      </div>
    </Card>
  );
}
